import {
  authorizedJsonRequest, handleWebResourceFailure, listData,
} from './web-resource-api';

require('dotenv').config();

const ENV = process.env;
const SORT_FIELDS = [
  'id', 'city_id', 'web_country_id', 'name_en', 'name_fr', 'name_ar', 'latitude',
  'longitude', 'timezone', 'priority', 'enabled', 'createdAt', 'updatedAt',
];

export const REQUEST_WEB_CITIES = 'REQUEST_WEB_CITIES';
export const RECEIVE_WEB_CITIES = 'RECEIVE_WEB_CITIES';
export const RECEIVE_WEB_CITY = 'RECEIVE_WEB_CITY';
export const COMPLETE_WEB_CITIES = 'COMPLETE_WEB_CITIES';

export const requestWebCities = () => ({ type: REQUEST_WEB_CITIES });
export const receivedWebCities = items => ({ type: RECEIVE_WEB_CITIES, items });
export const receivedWebCity = item => ({ type: RECEIVE_WEB_CITY, item });
export const completeWebCities = () => ({ type: COMPLETE_WEB_CITIES });

const mutation = (url, method, params) => dispatch => (
  authorizedJsonRequest(url, {
    method,
    headers: method === 'DELETE' ? {} : { 'Content-Type': 'application/json' },
    ...(params ? { body: JSON.stringify(params) } : {}),
  }).then((result) => {
    if (!result.ok) handleWebResourceFailure(dispatch, result);
    dispatch(completeWebCities());
    return result;
  })
);

export const fetchWebCities = sort => (dispatch) => {
  dispatch(requestWebCities());
  let url = `${ENV.REACT_APP_API_SERVER}/web-cities`;
  if (sort && SORT_FIELDS.includes(sort[0])) url += `?order=${JSON.stringify(sort)}`;

  return authorizedJsonRequest(url, { method: 'GET' }).then((result) => {
    if (result.ok) dispatch(receivedWebCities(listData(result.data)));
    else {
      handleWebResourceFailure(dispatch, result);
      dispatch(receivedWebCities([]));
    }
    return result;
  });
};

export const fetchWebCity = id => (dispatch) => {
  dispatch(requestWebCities());
  return authorizedJsonRequest(`${ENV.REACT_APP_API_SERVER}/web-cities/${id}`, { method: 'GET' })
    .then((result) => {
      if (result.ok) dispatch(receivedWebCity(result.data));
      else {
        handleWebResourceFailure(dispatch, result);
        dispatch(receivedWebCity({}));
      }
      return result;
    });
};

export const createWebCity = params => (dispatch) => {
  dispatch(requestWebCities());
  return mutation(`${ENV.REACT_APP_API_SERVER}/web-cities`, 'POST', params)(dispatch);
};

export const saveWebCity = (id, params) => (dispatch) => {
  dispatch(requestWebCities());
  return mutation(`${ENV.REACT_APP_API_SERVER}/web-cities/${id}`, 'POST', params)(dispatch);
};

export const deleteWebCity = id => (dispatch) => {
  dispatch(requestWebCities());
  return mutation(`${ENV.REACT_APP_API_SERVER}/web-cities/${id}`, 'DELETE')(dispatch);
};
